import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';

//Local modules
import { RegisterationModule } from './authentication/registration/registeration.module';
import { LoginModule } from './authentication/login/login.module';
import { ResetPasswordModule } from './authentication/resetPassword/resetPassword.module';

//Query file
import { ScheduleQueryService } from './gql-query-mutation/scheduleRequest';

const routes = [
    {
        path: 'home',
        loadChildren: './home/home.module#HomeModule'
    }
];

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        //Local modules
        RegisterationModule,
        LoginModule,
        ResetPasswordModule
    ],
    declarations: [
    ],
    providers: [
        ScheduleQueryService
    ]
})
export class FuseAppsModule {
}



// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/apps.module.ts